import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "component-title fw-bold small border-bottom pb-2 mb-3" };
const _hoisted_2 = { class: "d-flex align-items-center flex-wrap" };
const _hoisted_3 = {
    key: 0,
    class: "btn btn-secondary d-inline-flex align-items-center mb-3 me-3",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#bottleSelectionFilter"
};
const _hoisted_4 = {
    key: 0,
    class: "collapse mb-3",
    id: "bottleSelectionFilter"
};
const _hoisted_5 = { class: "row g-3" };
const _hoisted_6 = {
    key: 0,
    class: "col-lg-4 col-12"
};
const _hoisted_7 = {
    key: 1,
    class: "col-lg-4 col-12"
};
const _hoisted_8 = {
    key: 2,
    class: "col-lg-4 col-12"
};
const _hoisted_9 = {
    key: 3,
    class: "col-lg-4 col-12"
};
const _hoisted_10 = {
    key: 4,
    class: "col-lg-4 col-12"
};
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = {
    key: 0,
    class: "col-12 col-xl-3 col-xxl-2 position-relative d-flex align-items-center"
};
const _hoisted_14 = { class: "current-selection-badge badge text-bg-success position-absolute top-0 start-0" };
const _hoisted_15 = {
    class: "btn bg-light border border-2 border-success rounded-3 p-0 w-100 gallery-btn",
    style: { "overflow": "hidden" }
};
const _hoisted_16 = {
    class: "w-100 bg-white py-3",
    style: { "height": "300px" }
};
const _hoisted_17 = ["src"];
const _hoisted_18 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_19 = { class: "text-center fw-bold" };
const _hoisted_20 = { class: "text-center fw-bold small" };
const _hoisted_21 = { class: "text-center" };
const _hoisted_22 = { class: "m-2 position-relative" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
    class: "w-100 bg-white py-3",
    style: { "height": "300px" }
};
const _hoisted_25 = ["src"];
const _hoisted_26 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_27 = { class: "text-center fw-bold" };
const _hoisted_28 = { class: "text-center fw-bold small" };
const _hoisted_29 = { class: "text-center" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "small text-muted mt-3" };
const _hoisted_32 = {
    key: 2,
    class: "d-flex justify-content-center align-items-center flex-column"
};
const _hoisted_33 = { class: "fw-bold text-primary" };
const _hoisted_34 = {
    key: 0,
    id: "contextModal",
    class: "d-flex flex-wrap align-items-center justify-content-center"
};
const _hoisted_35 = { class: "m-2 position-relative" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
    class: "w-100 bg-white py-3",
    style: { "height": "300px" }
};
const _hoisted_38 = ["src"];
const _hoisted_39 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_40 = { class: "text-center fw-bold" };
const _hoisted_41 = { class: "text-center fw-bold small" };
const _hoisted_42 = { class: "text-center" };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
    key: 0,
    id: "contextModal"
};
const _hoisted_45 = { class: "d-block d-md-flex justify-content-between align-items-center mb-3" };
const _hoisted_46 = { class: "me-0 me-md-5" };
const _hoisted_47 = { class: "fw-bold mb-3 gallery-font-color" };
const _hoisted_48 = { class: "bg-light rounded p-3" };
const _hoisted_49 = { class: "row row-cols-1 row-cols-md-2 g-3" };
const _hoisted_50 = { class: "col" };
const _hoisted_51 = { class: "fw-bold gallery-font-color" };
const _hoisted_52 = { class: "m-0" };
const _hoisted_53 = { class: "col" };
const _hoisted_54 = { class: "fw-bold gallery-font-color" };
const _hoisted_55 = { class: "m-0" };
const _hoisted_56 = { class: "col" };
const _hoisted_57 = { class: "fw-bold gallery-font-color" };
const _hoisted_58 = { class: "m-0" };
const _hoisted_59 = { class: "col" };
const _hoisted_60 = { class: "fw-bold gallery-font-color" };
const _hoisted_61 = { class: "m-0" };
const _hoisted_62 = { class: "col" };
const _hoisted_63 = { class: "fw-bold gallery-font-color" };
const _hoisted_64 = { class: "m-0" };
const _hoisted_65 = { class: "d-flex justify-content-center" };
const _hoisted_66 = { class: "text-center" };
const _hoisted_67 = {
    class: "d-flex align-items-center justify-content-center",
    style: { "height": "300px" }
};
const _hoisted_68 = ["src"];
const _hoisted_69 = { class: "d-flex align-items-center justify-content-center h-100" };
const _hoisted_70 = ["src", "onClick"];
const _hoisted_71 = ["innerHTML"];
import axios from 'axios';
import { Carousel, MultiSelect, Select } from 'primevue';
import Swal from 'sweetalert2';
import { onMounted, ref, watch } from 'vue';
import { filters } from '../Composables/filters';
import ContextModal from './ContextModal.vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import { usePage } from '@inertiajs/vue3';
import { loadTenantConfigs } from '../Composables/standardFunctions';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BottleSelection',
    props: {
        configurationId: String,
        tenantId: {
            type: String,
            default: ''
        },
        showFilters: Boolean,
        publicFilters: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        let { formatCurrency } = formatters();
        let { showErrorSwal } = responseMessages();
        const { productCategories, selectedProductCategories, materials, selectedMaterials, volumes, selectedVolumes, bottleHeights, selectedBottleHeights, sodaStreamOptions, selectedSodaStreamOption, loadFilters, searchBottles } = filters();
        const props = __props;
        const emit = __emit;
        const page = usePage();
        const standardProductType = ref(null);
        const availablePublicFilters = page.props.iframes.publicFilters;
        const loading = ref(false);
        const bottles = ref([]);
        const detailsBottle = ref(null);
        const selectedBottle = ref(null);
        const dimensionSheetPrice = ref(0);
        const modal = ref();
        const modalAllProducts = ref();
        const responsiveOptions = ref([
            {
                breakpoint: '1900px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '1400px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '750px',
                numVisible: 1,
                numScroll: 1
            }
        ]);
        onMounted(async () => {
            standardProductType.value = await loadTenantConfigs('standard_product_type');
            loadFilters(props.tenantId, true);
            loadSavedSelection();
            calculateDimensionSheetPrice();
        });
        watch([
            selectedProductCategories,
            selectedMaterials,
            selectedVolumes,
            selectedBottleHeights,
            selectedSodaStreamOption
        ], () => {
            search();
        });
        async function search() {
            loading.value = true;
            try {
                bottles.value = await searchBottles(props.tenantId, selectedProductCategories.value, selectedMaterials.value, selectedVolumes.value, selectedBottleHeights.value, selectedSodaStreamOption.value, null);
            }
            catch (error) {
                console.log(error);
                loading.value = false;
            }
            finally {
                loading.value = false;
            }
        }
        function loadSavedSelection() {
            axios.post(route('configurator.bottles.selection.load', props.configurationId), {})
                .then(function (response) {
                if (response.data != null && response.data != '') {
                    selectedBottle.value = response.data;
                    emit('update', selectedBottle.value);
                }
                search();
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function showBottleDetails(bottle, event) {
            axios.post(route('configurator.bottles.selection.details.show', bottle.id), {})
                .then(function (response) {
                detailsBottle.value = response.data;
                modal.value.openAt(event.clientX, event.clientY);
            })
                .catch(function (error) {
                console.log(error);
                detailsBottle.value = null;
            });
        }
        function showAllProducts(event) {
            modalAllProducts.value.openAt(event.clientX, event.clientY);
        }
        function selectBottle(bottle, forceChange = false) {
            if (bottle == null) {
                return;
            }
            if (selectedBottle.value && selectedBottle.value.id != bottle.id && !forceChange) {
                Swal.fire({
                    title: standardProductType.value == 'glass' ? t('Möchten Sie wirklich ein anderes Glas wählen?') : t('Möchten Sie wirklich eine andere Flasche wählen?'),
                    text: t('Durch die Änderung gehen alle bereits durchgeführten Konfigurationen verloren.'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: t("Mit neuer Auswahl fortfahren"),
                    cancelButtonText: t("Auswahl beibehalten"),
                    confirmButtonColor: "#528399",
                    cancelButtonColor: "#dc3545",
                }).then((result) => {
                    if (result.isConfirmed) {
                        selectBottle(bottle, true);
                    }
                });
                return;
            }
            axios.post(route('configurator.bottles.selection.store', props.configurationId), {
                bottleId: bottle.id,
            })
                .then(function (response) {
                selectedBottle.value = bottle;
                modalAllProducts.value.close();
                emit('update', selectedBottle.value);
            })
                .catch(function (error) {
                console.log(error);
                showErrorSwal(error.response?.data || t('Fehler beim Speichern der Auswahl'));
            });
        }
        function calculateDimensionSheetPrice() {
            axios.post(route('configurator.priceCalculation.getDimensionSheetPrice', props.configurationId), {
                amount: 100
            })
                .then(function (response) {
                dimensionSheetPrice.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h5", _hoisted_1, _toDisplayString(standardProductType.value == 'glass' ? _unref(t)('Glas-Auswahl') : _unref(t)('Flaschen-Auswahl')), 1),
                _createElementVNode("div", _hoisted_2, [
                    (props.showFilters)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_3, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "20",
                                    fill: "currentColor",
                                    class: "bi bi-sliders",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
                                    })
                                ], -1)
                            ]))]))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", {
                        class: "btn btn-primary d-inline-flex align-items-center mb-3",
                        onClick: _cache[0] || (_cache[0] = ($event) => (showAllProducts($event)))
                    }, _toDisplayString(_unref(t)('Alle Produkte')), 1)
                ]),
                (props.showFilters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['product_categories']))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_unref(MultiSelect), {
                                        class: "w-100",
                                        modelValue: _unref(selectedProductCategories),
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(selectedProductCategories) ? (selectedProductCategories).value = $event : null)),
                                        options: _unref(productCategories),
                                        filter: "",
                                        optionLabel: "name",
                                        optionValue: "uuid",
                                        placeholder: _unref(t)('Produktkategorien')
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                ]))
                                : _createCommentVNode("", true),
                            (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['materials']))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(_unref(MultiSelect), {
                                        class: "w-100",
                                        modelValue: _unref(selectedMaterials),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(selectedMaterials) ? (selectedMaterials).value = $event : null)),
                                        options: _unref(materials),
                                        filter: "",
                                        optionLabel: "name",
                                        optionValue: "uuid",
                                        placeholder: _unref(t)('Materialien')
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                ]))
                                : _createCommentVNode("", true),
                            (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['volumes']))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_unref(MultiSelect), {
                                        class: "w-100",
                                        modelValue: _unref(selectedVolumes),
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(selectedVolumes) ? (selectedVolumes).value = $event : null)),
                                        options: _unref(volumes),
                                        filter: "",
                                        optionLabel: "name",
                                        optionValue: "value",
                                        placeholder: _unref(t)('Fassungsvermögen')
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                ]))
                                : _createCommentVNode("", true),
                            (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['heights']))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createVNode(_unref(MultiSelect), {
                                        class: "w-100",
                                        modelValue: _unref(selectedBottleHeights),
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(selectedBottleHeights) ? (selectedBottleHeights).value = $event : null)),
                                        options: _unref(bottleHeights),
                                        filter: "",
                                        optionLabel: "name",
                                        optionValue: "value",
                                        placeholder: _unref(t)('Höhe')
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                ]))
                                : _createCommentVNode("", true),
                            (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['soda_stream']))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(_unref(Select), {
                                        class: "w-100",
                                        modelValue: _unref(selectedSodaStreamOption),
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(selectedSodaStreamOption) ? (selectedSodaStreamOption).value = $event : null)),
                                        options: _unref(sodaStreamOptions),
                                        filter: "",
                                        optionLabel: "name",
                                        optionValue: "value",
                                        placeholder: _unref(t)('Soda-Stream-Eignung')
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (!loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            (selectedBottle.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('Aktuelle Auswahl')), 1),
                                    _createElementVNode("button", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("img", {
                                                src: selectedBottle.value.image,
                                                class: "h-100"
                                            }, null, 8, _hoisted_17)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(selectedBottle.value.name), 1),
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(selectedBottle.value.volume), 1),
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('ab')) + " " + _toDisplayString(_unref(formatCurrency)(selectedBottle.value.startPrice)) + " *", 1)
                                        ])
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn position-absolute end-0 top-0 mt-2 me-3",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (showBottleDetails(selectedBottle.value, $event)))
                                    }, [...(_cache[8] || (_cache[8] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "30",
                                                fill: "currentColor",
                                                class: "bi bi-info-circle-fill text-secondary",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
                                            ], -1)
                                        ]))])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                class: _normalizeClass(["col-12", { 'col-xl-9 col-xxl-10': selectedBottle.value != null, 'col-xl-12': selectedBottle.value == null }])
                            }, [
                                _createVNode(_unref(Carousel), {
                                    value: bottles.value,
                                    numVisible: 4,
                                    numScroll: 1,
                                    responsiveOptions: responsiveOptions.value,
                                    showIndicators: false,
                                    showNavigators: true,
                                    class: "w-100"
                                }, {
                                    item: _withCtx((slotProps) => [
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("button", {
                                                class: "btn bg-light border border-2 rounded-3 p-0 w-100 gallery-btn",
                                                style: { "overflow": "hidden" },
                                                onClick: ($event) => (selectBottle(slotProps.data))
                                            }, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("img", {
                                                        src: slotProps.data.image,
                                                        class: "h-100"
                                                    }, null, 8, _hoisted_25)
                                                ]),
                                                _createElementVNode("div", _hoisted_26, [
                                                    _createElementVNode("span", _hoisted_27, _toDisplayString(slotProps.data.name), 1),
                                                    _createElementVNode("span", _hoisted_28, _toDisplayString(slotProps.data.volume), 1),
                                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('ab')) + " " + _toDisplayString(_unref(formatCurrency)(slotProps.data.startPrice)) + " *", 1)
                                                ])
                                            ], 8, _hoisted_23),
                                            _createElementVNode("button", {
                                                class: "btn position-absolute end-0 top-0 mt-2 me-3",
                                                onClick: ($event) => (showBottleDetails(slotProps.data, $event))
                                            }, [...(_cache[9] || (_cache[9] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "30",
                                                        fill: "currentColor",
                                                        class: "bi bi-info-circle-fill text-secondary",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
                                                    ], -1)
                                                ]))], 8, _hoisted_30)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["value", "responsiveOptions"])
                            ], 2)
                        ]),
                        _createElementVNode("p", _hoisted_31, "* " + _toDisplayString(_unref(trans)('zzgl. Maßblattkosten in Höhe von {costs} Euro pro Gesamt-Konfiguration', { costs: _unref(formatCurrency)(dimensionSheetPrice.value) })), 1)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", {
                            class: "spinner-grow text-primary mb-3",
                            role: "status",
                            style: { "width": "3rem", "height": "3rem" }
                        }, [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                        ], -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('Auswahl wird geladen')), 1)
                    ])),
                _createVNode(ContextModal, {
                    ref_key: "modalAllProducts",
                    ref: modalAllProducts
                }, {
                    default: _withCtx(() => [
                        (bottles.value && bottles.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottles.value, (bottle) => {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        _createElementVNode("button", {
                                            class: "btn bg-light border border-2 rounded-3 p-0 w-100 gallery-btn",
                                            style: { "overflow": "hidden" },
                                            onClick: ($event) => (selectBottle(bottle))
                                        }, [
                                            _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("img", {
                                                    src: bottle.image,
                                                    class: "h-100"
                                                }, null, 8, _hoisted_38)
                                            ]),
                                            _createElementVNode("div", _hoisted_39, [
                                                _createElementVNode("span", _hoisted_40, _toDisplayString(bottle.name), 1),
                                                _createElementVNode("span", _hoisted_41, _toDisplayString(bottle.volume), 1),
                                                _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)('ab')) + " " + _toDisplayString(_unref(formatCurrency)(bottle.startPrice)) + " *", 1)
                                            ])
                                        ], 8, _hoisted_36),
                                        _createElementVNode("button", {
                                            class: "btn position-absolute end-0 top-0 mt-2 me-3",
                                            onClick: ($event) => (showBottleDetails(bottle, $event))
                                        }, [...(_cache[11] || (_cache[11] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "30",
                                                    fill: "currentColor",
                                                    class: "bi bi-info-circle-fill text-secondary",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
                                                ], -1)
                                            ]))], 8, _hoisted_43)
                                    ]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal
                }, {
                    default: _withCtx(() => [
                        (detailsBottle.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("h3", _hoisted_47, _toDisplayString(detailsBottle.value.name), 1),
                                        _createElementVNode("div", _hoisted_48, [
                                            _createElementVNode("div", _hoisted_49, [
                                                _createElementVNode("div", _hoisted_50, [
                                                    _createElementVNode("h6", _hoisted_51, _toDisplayString(_unref(t)('Volumen')), 1),
                                                    _createElementVNode("p", _hoisted_52, _toDisplayString(detailsBottle.value.volume), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_53, [
                                                    _createElementVNode("h6", _hoisted_54, _toDisplayString(_unref(t)('Höhe')), 1),
                                                    _createElementVNode("p", _hoisted_55, _toDisplayString(detailsBottle.value.height) + " mm", 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_56, [
                                                    _createElementVNode("h6", _hoisted_57, _toDisplayString(_unref(t)('Durchmesser')), 1),
                                                    _createElementVNode("p", _hoisted_58, _toDisplayString(detailsBottle.value.diameter) + " mm", 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_59, [
                                                    _createElementVNode("h6", _hoisted_60, _toDisplayString(_unref(t)('Material')), 1),
                                                    _createElementVNode("p", _hoisted_61, _toDisplayString(detailsBottle.value.material), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_62, [
                                                    _createElementVNode("h6", _hoisted_63, _toDisplayString(_unref(t)('Druckbereiche (Breite x Höhe)')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsBottle.value.printAreas, (printArea) => {
                                                        return (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(printArea.width) + " mm x " + _toDisplayString(printArea.height) + " mm", 1));
                                                    }), 256))
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("div", _hoisted_67, [
                                                _createElementVNode("img", {
                                                    src: detailsBottle.value.image,
                                                    class: "img-fluid rounded",
                                                    style: { "max-height": "300px", "max-width": "300px" }
                                                }, null, 8, _hoisted_68)
                                            ]),
                                            _createVNode(_unref(Carousel), {
                                                value: detailsBottle.value.images,
                                                numVisible: 3,
                                                numScroll: 1,
                                                responsiveOptions: responsiveOptions.value,
                                                showIndicators: false,
                                                showNavigators: true,
                                                class: "w-100 mt-3"
                                            }, {
                                                item: _withCtx((slotProps) => [
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _createElementVNode("img", {
                                                            src: slotProps.data,
                                                            class: "img-fluid rounded",
                                                            style: { "max-height": "1000px", "max-width": "100px", "cursor": "pointer" },
                                                            onClick: ($event) => { detailsBottle.value.image = slotProps.data; }
                                                        }, null, 8, _hoisted_70)
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["value", "responsiveOptions"])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", {
                                    innerHTML: detailsBottle.value.description,
                                    class: "mb-5"
                                }, null, 8, _hoisted_71)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
